import authorized from "@/middleware/authorized"
import paid from "@/middleware/paid"

export default {
    path: '/visits',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['visit_history_section'] },
    component: () => import('../components/pages/visits/Visits.vue')
}
